import { Box, Chip, Divider, Tooltip, Typography } from '@mui/material'
import React from 'react'
import Grid from '@mui/material/Grid2';
import ClientVoucherEntityTypeIcon from './ClientVoucherEntityTypeIcon';
import { handleViewSingleVoucher } from 'src/store/reservations/actions/ReservationClientVoucherActions';
import CustomClientVoucherReference from './CustomClientVoucherReference';

const ElementReferenceList = ({ dispatch, navigate, items, reservationDetails }) => {
    return (
        <Box>
            {items.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                    No items found
                </Typography>
            ) : (
                <>
                    {items.map((item, index) => (
                        <Box key={index}>
                            <Grid container spacing={2} pl={13} alignItems="center">                                
                                <Grid size={3}>
                                    <CustomClientVoucherReference
                                                    voucherId={reservationDetails.Id}
                                                    itemReference={item.ItemReference}
                                                />
                                </Grid>
                                <Grid size={2}>
                                    <ClientVoucherEntityTypeIcon value={item.EntityType} />
                                </Grid>
                                <Grid size={3} pl={8}>
                                    <Tooltip title={`Hotel Name: ${item.Name}`}>
                                        <Typography variant="body2">
                                            {item.Name}
                                        </Typography>
                                    </Tooltip>
                                </Grid>
                                <Grid size={1}>
                                </Grid>
                                <Grid size={3} pl={7} display="flex" justifyContent="center">
                                    <Tooltip title="View Single Voucher">
                                        <Chip
                                            color="primary"
                                            sx={{ borderRadius: '6px' }}
                                            size="small"
                                            label="View"
                                            onClick={() => handleViewSingleVoucher(reservationDetails.ReservationId, reservationDetails.Id, dispatch, navigate, item.ItemReference)}
                                        />
                                    </Tooltip>
                                </Grid>

                            </Grid>
                            {index < items.length - 1 && <Divider sx={{ my: 1 }} />}
                        </Box>
                    ))}
                </>
            )}
        </Box>
    )
}

export default ElementReferenceList